import type {FontsByName} from './ThemeImpl';

const fontsByName: FontsByName = {
  base: 'Inter_400Regular',
  time: 'Inter_800ExtraBold',
  quoteBody: 'Inter_400Regular',
  header6: 'Inter_500Medium',
  header5: 'Inter_600SemiBold',
};

export default fontsByName;
